import React, {useCallback} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {createPortal} from "react-dom";
import {func} from "prop-types";
import {useOnClickOutside} from "services/utils/utils";
import {Icon} from "features/components/icon";
import {notificationListFetchNextPage, notificationListStart} from "store/reducer/notifications/list/reducer";
import {
    notificationListData,
    notificationListErrorSelector,
    notificationListHasNextPage,
    notificationListLoadingSelector, notificationListNextLoadingSelector
} from "store/reducer/notifications/list/selectors";
import {notificationCountData} from "store/reducer/notifications/count/selectors";
import Button from "features/components/button";
import Text from "features/components/text";
import {__} from "services/i18n";
import Title from "features/components/title";
import {NotificationItem} from "features/modals/notifications/item";
import {
    notificationDeleteErrorSelector,
    notificationDeleteLoadingSelector
} from "store/reducer/notifications/delete/selectors";
import {notificationDeleteStart} from "store/reducer/notifications/delete/reducer";
/* istanbul ignore next */
const mapStateToProps = state => ({
    has_next_page: notificationListHasNextPage(state),
    loading: notificationListLoadingSelector(state),
    error: notificationListErrorSelector(state),
    next_loading: notificationListNextLoadingSelector(state),
    list: notificationListData(state),
    unread_count: notificationCountData(state),
    delete_loading: notificationDeleteLoadingSelector(state),
    delete_error: notificationDeleteErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    notificationListStart,
    notificationListFetchNextPage,
    notificationDeleteStart
};

export const NotificationsModal = (props) => {
    const {has_next_page, loading, error, next_loading, list, unread_count, delete_loading, delete_error} = props;
    const {onClose, notificationListStart, notificationListFetchNextPage, notificationDeleteStart} = props;

    const outsideRef = React.useRef(null);
    /* istanbul ignore next */
    useOnClickOutside(outsideRef, () => {
        onClose();
    });

    React.useEffect(() => {
        notificationListStart()
    }, [notificationListStart])

    const renderNext = useCallback(() => {
        if(has_next_page) {
            return <div className="load-more">
                <Button title={__("buttons.load-more")} onClick={notificationListFetchNextPage} type={"outlined"} status={next_loading ? "loading" : null} />
            </div>
        }
        return <Text size={16} align={"center"}>{__("notifications.no-more-notifications")}</Text>
    }, [has_next_page, next_loading, notificationListFetchNextPage]);

    const renderContent = useCallback(() => {
        if(loading) {
            return <Icon>loader</Icon>
        }
        return <>
            <div className="row top-row">
                <div>
                    {unread_count > 0 && <span className="unread-mark" />}
                    <Title size={18}>{__("notifications.notification-number", [{key: "[count]", value: unread_count}])}</Title>
                </div>
                <Button title={__("buttons.delete-all")} onClick={notificationDeleteStart} type={"clear"} disabled={list.length === 0} status={delete_loading ? "loading" : null} />
            </div>
            {delete_error.inError && <Text size={16} color={"danger"}>{__(delete_error.error)}</Text>}
            <div className="notifications">
                {list.map((item, index) => <NotificationItem key={index} notification={item} />)}
            </div>
            {error.inError && <Text size={16} color={"danger"} align={"center"}>{__(error.error)}</Text>}
            {renderNext()}
        </>
    }, [delete_error.error, delete_error.inError, delete_loading, error.error, error.inError, list, loading, notificationDeleteStart, renderNext, unread_count]);

    return <div ref={outsideRef} className={"notifications-modal"}>
        <div onClick={onClose} className="clear-btn"><Icon>clear-circle-outlined</Icon></div>
        {renderContent()}
    </div>
};
NotificationsModal.propTypes = {
    onClose: func.isRequired
}

const NotificationsModalConnected = connect(mapStateToProps, mapDispatchToProps)(NotificationsModal);
/* istanbul ignore next */
export const NotificationsModalPortal = props => createPortal(
    <div className={"portal search-modal-portal"}><NotificationsModalConnected {...props}/></div>,
    document.body
);